enum InvoiceType {
  INVOICE = 'INVOICE',
  PRE_INVOICE = 'PRE_INVOICE',
  CORRECTION_INVOICE = 'CORRECTION',
  FIXED_PRICE_INVOICE = 'FIXED_PRICE'
}

export default InvoiceType;
